import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import { listenPushSounds } from "../utils/notificationSounds";

export default function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try {
      const stored = localStorage.getItem("sidebarCollapsed");
      return stored === "true";
    } catch {
      return false;
    }
  });

  // Som das notificações push (venda aprovada / bot offline) com a aba aberta.
  useEffect(() => listenPushSounds(), []);

  useEffect(() => {
    try {
      localStorage.setItem("sidebarCollapsed", sidebarCollapsed ? "true" : "false");
    } catch {
      // ignore persistence errors
    }
  }, [sidebarCollapsed]);

  return (
    <div
      className={`app-layout ${
        sidebarCollapsed ? "sidebar-collapsed" : "sidebar-expanded"
      }`}
    >
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggleCollapse={setSidebarCollapsed}
      />
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
